import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import API from '../../constants/api';
import { addPicture } from '../reducers/picturesReducer';
import { catchError } from '../reducers/commonReducer';
import errorChecker from './errorChecker';

export function putPicture(file, massName) {
  return async dispatch => {
    const photo = {
      name: file.name,
      size: file.size,
      lastModified: file.lastModified,
      createDate: new Date().getTime(),
      numberOfCopies: 1,
    };
    let arrayBuffer;
    try {
      arrayBuffer = await readFileAsync(file);
    } catch (err) {
      dispatch(catchError(err));
      console.log(err);
      return err;
    }
    return fetch(API.mainAPI + API.uploadPicture, {
      method: 'post',
      body: arrayBuffer,
    })
      .then(errorChecker)
      .then(data => dispatch(addPicture({ photo, data, massName })))
      .catch(err => {
        dispatch(catchError(err));
        console.log(err);
      });
  };
}

function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}
